<template>
    <div class="border-y-4" :style="{ borderColor: borderColor }">
      <div class="max-w-screen-xl px-4 py-10 mx-auto lg:py-20">
        <div class="grid items-center grid-cols-12 gap-x-3 gap-y-6">
          <div class="col-span-12 md:col-span-3">
            <nuxt-img
              :src="imageSrc1"
              :alt="imageAlt1"
              loading="lazy"
              format="webp"
              :width="164"
              :height="279"
              sizes="xs:164px sm:164px md:164px lg:164px xl:164px 2xl:164px"
              class="block object-cover m-auto"
            />
          </div>
  
          <div class="col-span-12 md:col-span-6">
            <div
              class="text-center uppercase h2"
              v-html="quoteText"
              :style="{ color: quoteTextColor }"
            ></div>
            <div
              class="mt-4 text-center h4"
              v-html="descriptionText"
              :style="{ color: descriptionTextColor }"
            ></div>
          </div>
  
          <div class="col-span-12 md:col-span-3">
            <nuxt-img
              :src="imageSrc2"
              :alt="imageAlt2"
              loading="lazy"
              format="webp"
              :width="164"
              :height="186"
              sizes="xs:164px sm:164px md:164px lg:164px xl:164px 2xl:164px"
              class="block object-cover m-auto"
            />
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  const props = defineProps({
    imageSrc1: {
      type: String,
      default: '/assets/images/rainforest.webp',
    },
    imageAlt1: {
      type: String,
      default: 'Rainforest Trust Badge',
    },
    imageSrc2: {
      type: String,
      default: '/assets/images/project-alianza-logo.jpg',
    },
    imageAlt2: {
      type: String,
      default: 'Project Alianza Logo',
    },
    quoteText: {
      type: String,
      default: '“Drink Coffee and Save the Planet”',
    },
    quoteTextColor: {
      type: String,
      default: '#000000',
    },
    descriptionText: {
      type: String,
      default:
        'A portion of the profits are donated to Rainforest Trust and Project Alianza for conservation of the wild life and to build schools in local areas for the farmers children.',
    },
    descriptionTextColor: {
      type: String,
      default: '#000000',
    },
    borderColor: {
      type: String,
      default: '#4A90E2',
    },
  });
  
  defineBuilderComponent({
    friendlyName: 'Description Left Right Image',
    inputs: [
      {
        name: 'imageSrc1',
        type: 'file',
        allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
        friendlyName: 'First Image Source',
        defaultValue: '/assets/images/rainforest.webp',
      },
      {
        name: 'imageAlt1',
        type: 'string',
        friendlyName: 'First Image Alt Text',
        defaultValue: 'Rainforest Trust Badge',
      },
      {
        name: 'quoteText',
        type: 'richText',
        friendlyName: 'Quote Text',
        defaultValue: '“Drink Coffee and Save the Planet”',
      },
      {
        name: 'quoteTextColor',
        type: 'color',
        friendlyName: 'Quote Text Color',
        defaultValue: '#000000',
      },
      {
        name: 'descriptionText',
        type: 'richText',
        friendlyName: 'Description Text',
        defaultValue:
          'A portion of the profits are donated to Rainforest Trust and Project Alianza for conservation of the wild life and to build schools in local areas for the farmers children.',
      },
      {
        name: 'descriptionTextColor',
        type: 'color',
        friendlyName: 'Description Text Color',
        defaultValue: '#000000',
      },
      {
        name: 'imageSrc2',
        type: 'file',
        allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
        friendlyName: 'Second Image Source',
        defaultValue: '/assets/images/project-alianza-logo.jpg',
      },
      {
        name: 'imageAlt2',
        type: 'string',
        friendlyName: 'Second Image Alt Text',
        defaultValue: 'Project Alianza Logo',
      },
      {
        name: 'borderColor',
        type: 'color',
        friendlyName: 'Border Color',
        defaultValue: '#4A90E2',
      },
    ],
  });
  </script>